(() => {
  'use strict';
  if (window.__gemmyEasyGiftCompatLoaded) return;
  window.__gemmyEasyGiftCompatLoaded = true;

  const GIFT_VARIANT_ID = 55080537260331;
  const GIFT_PROPERTY = '_Gifted';
  const TIERS = [
    { minimum: 3, quantity: 6, rule: 'Buy 3 Get 6 Mystery Bracelets' },
    { minimum: 2, quantity: 3, rule: 'Buy 2 Get 3 Mystery Bracelets' },
    { minimum: 1, quantity: 1, rule: 'Buy 1 Get 1 Mystery Bracelet' },
  ];
  const fetchBeforeCompat = window.fetch.bind(window);
  let timer = null;
  let syncing = false;
  let rerun = false;

  const isInternal = (url) => String(url || '').includes('_easygift_internal=true');
  const isCartMutation = (url, method) =>
    /\/cart\/(add|change|update|clear)(\.js)?(?:\?|$)/.test(String(url || '')) && String(method || 'GET').toUpperCase() !== 'GET';

  const request = async (path, options = {}) => {
    const response = await fetchBeforeCompat(path, { credentials: 'same-origin', ...options });
    if (!response.ok) throw new Error('Gemmy EasyGift compatibility request failed: ' + response.status);
    return response.json();
  };

  const schedule = (delay = 650) => {
    clearTimeout(timer);
    timer = setTimeout(syncGift, delay);
  };

  async function syncGift() {
    if (syncing) {
      rerun = true;
      return;
    }
    syncing = true;
    try {
      const cart = await request('/cart.js?_easygift_internal=true');
      const qualifyingQuantity = cart.items.reduce((sum, item) => {
        if (Number(item.variant_id) === GIFT_VARIANT_ID) return sum;
        return sum + Number(item.quantity || 0);
      }, 0);
      const tier = TIERS.find((candidate) => qualifyingQuantity >= candidate.minimum) || null;
      const giftLines = cart.items.filter((item) =>
        Number(item.variant_id) === GIFT_VARIANT_ID && item.properties && item.properties[GIFT_PROPERTY]
      );
      const alreadyCorrect = tier && giftLines.length === 1 &&
        Number(giftLines[0].quantity) === tier.quantity &&
        giftLines[0].properties[GIFT_PROPERTY] === tier.rule;
      if (alreadyCorrect || (!tier && giftLines.length === 0)) return;

      if (giftLines.length) {
        const updates = Object.fromEntries(giftLines.map((item) => [item.key, 0]));
        await request('/cart/update.js?_easygift_internal=true', {
          method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ updates }),
        });
      }
      if (tier) {
        await request('/cart/add.js?_easygift_internal=true', {
          method: 'POST', headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: [{ id: GIFT_VARIANT_ID, quantity: tier.quantity, properties: { [GIFT_PROPERTY]: tier.rule } }] }),
        });
      }
      window.location.reload();
    } catch (error) {
      console.error('[Gemmy EasyGift compatibility]', error);
    } finally {
      syncing = false;
      if (rerun) {
        rerun = false;
        schedule(250);
      }
    }
  }

  window.fetch = async function compatFetch(input, init = {}) {
    const url = typeof input === 'string' ? input : input && input.url;
    const method = init.method || (input && input.method) || 'GET';
    const response = await fetchBeforeCompat(input, init);
    if (isCartMutation(url, method) && !isInternal(url)) schedule();
    return response;
  };

  document.addEventListener('click', (event) => {
    const target = event.target instanceof Element ? event.target.closest('button, a, input') : null;
    if (target && target.closest('cart-drawer, cart-items, form[action*="/cart"], .cart-drawer, #cart')) schedule(900);
  }, true);
  window.addEventListener('pageshow', () => schedule(900));
  schedule(1200);
})();
